import React from 'react'
import { HUELLA_TYPE } from "../config/settings/constant";
import routes from "../config/settings/routes";
import { usePathParam } from "../modules/hooks/route";
import ProtectBySession from "../components/Security/ProtectBySession";
import BrandLayout from "../components/Layouts/BrandLayout";
import { Map } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'
import Navbar from "../containers/Navbar/Navbar.container";
import ManagementMenu from "../containers/ManagementMenu/ManagementMenu.container";
import Heading from "../components/Layouts/Heading";
import HuellaContainer from '../containers/Huella/Dashboard/Huella.container';
import RalentiContainer from '../containers/Huella/Ralenti/Ralenti.container';
import AccessControl from '../components/Security/ProtectByGroup';


/**
 * The Records page.
 */
const Huella = () => {
    const type = usePathParam('type').toUpperCase();

    const TypeTitle = type => {
        switch (type) {
            case HUELLA_TYPE.DASHBOARD:
                return 'Vista Individual de Movimientos Recientes'
            case HUELLA_TYPE.RALENTI:
                return 'Eventos de Ralentí'
        }
    };

    const getTooltipContent = type => {
        switch (type) {
            case HUELLA_TYPE.DASHBOARD:
                return 'Consulte de forma individual los recorridos y la velocidad de los equipos en el último día.'
            case HUELLA_TYPE.RALENTI:
                return 'Consulte de forma individual los eventos de ralentí de los equipos en el último día.'
        }
    };

    const HuellaBreadcrumbs = () => {
        return (
            <Breadcrumb noTrailingSlash>
                <BreadcrumbItem>
                    <a href="/">Salar</a>
                </BreadcrumbItem>
                {HUELLA_TYPE[type] !== HUELLA_TYPE['HUELLA-INITIAL'] && <BreadcrumbItem isCurrentPage>{TypeTitle(type)}</BreadcrumbItem>}
            </Breadcrumb>
        )
    }

    const typeToComponentMap = {
        [HUELLA_TYPE.DASHBOARD]: HuellaContainer,
        [HUELLA_TYPE.RALENTI]: RalentiContainer
    }
    const ComponentToRender = typeToComponentMap[type];
    console.log('cositas', typeToComponentMap[type]);


    return (
        <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
            <BrandLayout
                navbar={<Navbar managementMenu={<ManagementMenu current={routes.huella} />} />}
                header={<Heading title={TypeTitle(type)} icon={<Map size={50} />} breadcrumbs={<HuellaBreadcrumbs />} tooltipContent={getTooltipContent(type)} />}
            >
                <AccessControl type={type}>
                    {ComponentToRender ? <ComponentToRender /> : <div>Component not found</div>}
                </AccessControl>
            </BrandLayout>
        </ProtectBySession>
    )
}

export default Huella